import { TYPES } from "../segments/FileSystem";

class App {
  #data;
  #parent;
  #appData;
  constructor(name, hash, parent, data, icon, appData = {}) {
    this.#parent = parent;
    this.metadata = {
      name: name,
      hash: hash,
      size: data.length,
      type: TYPES.APP,
      icon: icon,
    };
    this.#data = data;
    this.#appData = appData;
  }

  changeParent(parent) {
    this.#parent = parent;
  }

  changeIcon(icon) {
    this.metadata.icon = icon;
  }

  changeName(name) {
    this.metadata.name = name;
  }

  saveData(data) {
    this.#data = data;
    this.metadata.size = data.length;
  }

  getStorage(key) {
    return this.#appData[key];
  }

  getAppData() {
    return this.#appData;
  }

  setStorage(key, value) {
    this.#appData[key] = value;
  }

  getMetaData() {
    return this.metadata;
  }

  getIcon() {
    return this.metadata.icon;
  }

  getType() {
    return this.metadata.type;
  }

  getName() {
    return this.metadata.name;
  }

  getHash() {
    return this.metadata.hash;
  }

  getSize() {
    return this.#data.length;
  }

  getData() {
    return this.#data;
  }

  getParent() {
    return this.#parent;
  }

  clone() {
    return new App(
      this.metadata.name,
      this.metadata.hash,
      this.#parent,
      this.#data,
      this.metadata.icon
    );
  }
}

export default App;
